import React, { ForwardedRef, useState } from 'react';
import ReactSelect, {
  GroupBase,
  mergeStyles,
  SelectInstance,
} from 'react-select';
import { AsyncCreatableProps } from 'react-select/async-creatable';
import DashboardAccordionOption from './DashboardAccordionOption';
import { hofForwardRef } from '../../../../../utils/types';
import {
  EmptyComponent,
  getDefaultStyles,
} from '../../../../Dropdown/StyledReactSelect/SelectUtils';
import { MENU_LIST_CLASSNAME } from '../../../../Dropdown/StyledReactSelect/utils';
import SingleValue from './SingleValue';
import { CustomOption } from '../types';
import { useFloatingLayerContext } from '../../../../FloatingManager';

export default hofForwardRef(
  (
    {
      styles,
      components,
      menuPlacement,
      placeholder,
      ...props
    }: AsyncCreatableProps<CustomOption, false, GroupBase<CustomOption>>,
    ref: ForwardedRef<
      SelectInstance<CustomOption, false, GroupBase<CustomOption>>
    >,
  ) => {
    const [searchTerm, setSearchTerm] = useState('');
    const zIndex = useFloatingLayerContext();

    const selectStyles = mergeStyles(
      getDefaultStyles<CustomOption, false, GroupBase<CustomOption>>(zIndex),
      styles,
    );

    // temporary search solution to search through suboptions.
    // will refactor in the future with @leeoniya/ufuzzy library
    const customFilterOption = (option: any, inputValue: string) => {
      // check if the main option label matches the search input
      const mainOptionMatch = option.label
        .toLowerCase()
        .includes(inputValue.toLowerCase());

      // check if any of the subOptions match the search input
      const subOptionMatch = option.data.subOptions?.some(
        (subOption: CustomOption) =>
          subOption.label.toLowerCase().includes(inputValue.toLowerCase()),
      );

      return mainOptionMatch || subOptionMatch;
    };

    return (
      <ReactSelect
        {...props}
        ref={ref}
        menuPlacement={menuPlacement || 'auto'}
        placeholder={placeholder || ''}
        styles={selectStyles}
        isClearable={props?.isClearable ?? true}
        noOptionsMessage={() => (props.isLoading ? 'Loading...' : 'No options')}
        classNames={{
          menuList: () => MENU_LIST_CLASSNAME,
        }}
        inputValue={searchTerm}
        onInputChange={setSearchTerm}
        filterOption={customFilterOption} // Use custom filter logic
        components={{
          Option: (props) => (
            <DashboardAccordionOption {...props} searchTerm={searchTerm} />
          ),
          MultiValueRemove: EmptyComponent,
          DropdownIndicator: EmptyComponent,
          IndicatorSeparator: EmptyComponent,
          ClearIndicator: EmptyComponent,
          LoadingIndicator: EmptyComponent,
          SingleValue,
          ...components,
        }}
      />
    );
  },
);
